import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const DocumentsTabStyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px;

  .main-tab-column {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: flex-start;
  }

  .main-tab-button {
    max-width: none;
    text-align: center;
    height: 45px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 5px 50px;
    border-radius: 8px;

    color: ${({ theme }) => theme.palette.secondary.main};
  }
`;

export { DocumentsTabStyledContainer };
